module.exports = __webpack_public_path__ + "static/media/google.87be59a1.svg";